import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-EDM-Basic-data",
  "use": "icon-EDM-Basic-data-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-EDM-Basic-data\"><defs><style type=\"text/css\"></style></defs><path d=\"M229.248 385.152h85.12V658.24h-85.12V385.152z m240.896-102.4h85.12V658.24h-85.12V282.752z m0 503.488h85.12v192h-85.12v-192z m285.824 152.64V1024H278.4v-85.12h477.44zM1024 794.752H0V43.84h1024v750.912z m-85.12-85.12V128.96H85.12v580.672h853.76z m-135.424-529.28V658.24h-85.12V180.352h85.12z\" p-id=\"6497\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol